module.exports = __webpack_public_path__ + "static/media/ape-nation.5eeac1c9.png";